import NavBar from './components/NavBar';
import MainSpace from './components/MainSpace';
import PuzzleNav from './components/PuzzleNav';
import {Route, Routes, useLocation} from "react-router-dom";
import {useState, useEffect} from 'react';
import useMediaQuery from './components/MediaQuery.js';


function App() {
  const puzzleConfigs = {
    "2×2×2": {
      name: "2×2×2", 
      dimensions: { x: 2, y: 2, z: 2 },
      camera: null, 
      view: null,
      position: null, 
      saveCamera: null, 
      saveView: null,
      savePosition: null
    },
    "2×4×4": {
      name: "2×4×4", 
      dimensions: { x: 2, y: 4, z: 4 },
      camera: null, 
      view: null,
      position: null,
      saveCamera: null, 
      saveView: null,
      savePosition: null
    },
    "3×3×3": {
      name: "3×3×3", 
      dimensions: { x: 3, y: 3, z: 3 },
      camera: null, 
      view: null,
      position: null,
      saveCamera: null, 
      saveView: null,
      savePosition: null
    },
    "4×4×4": {
      name: "4×4×4", 
      dimensions: { x: 4, y: 4, z: 4 },
      camera: null, 
      view: null, 
      position: null,
      saveCamera: null, 
      saveView: null,
      savePosition: null
    }
  }

  const [menuOpen, setMenuOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    if (!isMobile) {
      setMenuOpen(false);
    }
  }, [isMobile])

  if (!localStorage.getItem("puzzles")) {
    localStorage.setItem("puzzles", JSON.stringify(puzzleConfigs));
  }

  const [currentPuzzleName, setCurrentPuzzleName] = useState(() => {
    if (!localStorage.getItem("currentPuzzle")) {
      localStorage.setItem("currentPuzzle", "3×3×3");
      return "3×3×3";
    } else {
      return localStorage.getItem("currentPuzzle");
    }
  });

  const location = useLocation();
  const [puzzleNav, setPuzzleNav] = useState(false);
  useEffect(() => {
    const background = location.state?.background;

    const isPuzzlePage =
      location.pathname === "/Puzzles" ||
      background?.pathname === "/Puzzles";

    if (isPuzzlePage) {
      setPuzzleNav(true);
    } else {
      if (document.getElementById('puzzleNav')) {
        document.getElementById('puzzleNav').style.width = 0;
        setTimeout(() => setPuzzleNav(false), 500);
      }
    }
  }, [location.pathname, location.state]);

  return (
    <div className='background'>
      {!isMobile && (
        <NavBar />
      )}
      <div className='page-content'>
        <MainSpace currentPuzzleName={currentPuzzleName} setCurrentPuzzleName={setCurrentPuzzleName}/>
        {/*<Routes>
          <Route path="/puzzles" element={<PuzzleNav />}/>
        </Routes>*/}
        {(puzzleNav && !isMobile) ? <PuzzleNav setCurrentPuzzleName={setCurrentPuzzleName}/> : null }
      </div>
    </div>
  );
}

export default App;
